if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('.button-text');
        this.submitButtonPrice = this.submitButton.querySelector('.button-price');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, variant) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          // Only update button text on desktop, not mobile
          if (text && window.innerWidth >= 750) {
            this.submitButtonText.textContent = text;
          }
          // Only hide price on desktop, not mobile
          if (this.submitButtonPrice && window.innerWidth >= 750) {
            this.submitButtonPrice.style.display = 'none';
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          // Only update button text on desktop, not mobile
          if (window.innerWidth >= 750) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
          // Only show price on desktop, not mobile
          if (this.submitButtonPrice && window.innerWidth >= 750) {
            this.submitButtonPrice.style.display = 'inline';
          }
          // Only update price on desktop, not mobile
          if (variant && this.submitButtonPrice && window.innerWidth >= 750) {
            this.updateButtonPrice(variant);
          }
        }
      }

      updateButtonPrice(variant) {
        if (!this.submitButtonPrice || !variant) return;
        const priceInCents = variant.price;
        const currentText = this.submitButtonPrice.textContent;
        const currencySymbol = currentText.match(/[^0-9.,\s]/)?.[0] || '$';
        const formattedPrice = (priceInCents / 100).toFixed(2);
        this.submitButtonPrice.textContent = currencySymbol + formattedPrice;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// =====================================================================
// Bold Subscriptions Widget - Custom layout transformer
// Converts the default Bold widget into a two-column card layout:
//   - Subscribe & Save card on top (with "How subscriptions work" checklist
//     on the left + a Delivery Frequency <select> on the right)
//   - One-time Purchase card below
// =====================================================================
var bsubIsUpdating = false;

function bsubCleanFrequencyLabel(text) {
  if (!text) return '';
  // "Monthly (25% off $29.99)" -> "Monthly 25% off"
  return text
    .replace(/\(([^)]*)\)/g, '$1')        // strip parens
    .replace(/off\s+\$[\d,.]+/i, 'off')   // strip trailing price
    .replace(/\s+/g, ' ')
    .trim();
}

function bsubSyncMainTexts(widget) {
  // Keep the (now hidden) radio labels clean too, in case the widget
  // re-reads them anywhere.
  if (bsubIsUpdating) return;
  bsubIsUpdating = true;
  widget.querySelectorAll('.bsub-widget__main-text').forEach(function (el) {
    var updated = el.innerHTML.replace(/(off)\s+\$[\d,.]+/, '$1');
    if (updated !== el.innerHTML) el.innerHTML = updated;
  });
  bsubIsUpdating = false;
}

function bsubBuildLayout(widget) {
  if (!widget || widget.dataset.tlLayout === '1') return;

  var groupsContainer = widget.querySelector('.bsub-widget__groups-container');
  var oneTimeInput = widget.querySelector('[data-bsub-purchase-option-one-time]');
  var oneTimeGroup = oneTimeInput ? oneTimeInput.closest('.bsub-widget__group') : null;
  var subGroup = widget.querySelector('[data-bsub-selling-plan-group]');
  var optionsContainer = widget.querySelector('.bsub-options-container');

  if (!groupsContainer || !subGroup || !optionsContainer) return;

  // 1. Reorder: Subscribe first, One-time after.
  if (oneTimeGroup) groupsContainer.appendChild(oneTimeGroup);

  // 2. Move the options panel INSIDE the subscribe card so it appears
  //    directly under its header.
  subGroup.appendChild(optionsContainer);

  // 3. Rewrite the Subscribe header text -> "Subscribe & Save XX%"
  //    Bold initially injects a placeholder like "(Save up to {discount})"
  //    and replaces {discount} with a real percent later via JS. We extract
  //    on init AND observe the source for updates so the title stays current.
  var discountSummary = subGroup.querySelector('[data-bsub-group-discount-summary]');
  var textEl = subGroup.querySelector('.bsub-widget__group-label .bsub-widget__text');

  function extractPct(el) {
    if (!el) return '';
    var m = el.textContent.match(/(\d+)\s*%/);
    return m ? m[1] + '%' : '';
  }

  var pctSpan = null;
  if (textEl) {
    var titleSpan = document.createElement('span');
    titleSpan.className = 'tl-bsub-title';
    titleSpan.appendChild(document.createTextNode('Subscribe & '));
    var saveSpan = document.createElement('span');
    saveSpan.className = 'tl-bsub-save-word';
    saveSpan.textContent = 'Save ';
    titleSpan.appendChild(saveSpan);
    pctSpan = document.createElement('span');
    pctSpan.className = 'tl-bsub-pct';
    pctSpan.textContent = extractPct(discountSummary);
    titleSpan.appendChild(pctSpan);

    // Clear and rebuild .bsub-widget__text. We preserve the original
    // discount-summary node (re-appended hidden) so Bold can keep
    // updating it; we observe it and mirror the value into pctSpan.
    textEl.innerHTML = '';
    textEl.appendChild(titleSpan);
    if (discountSummary) textEl.appendChild(discountSummary);
  }

  if (discountSummary && pctSpan) {
    var pctObs = new MutationObserver(function () {
      var next = extractPct(discountSummary);
      if (next && next !== pctSpan.textContent) pctSpan.textContent = next;
    });
    pctObs.observe(discountSummary, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  // 4. Build a <select> mirroring the delivery-frequency radios.
  var freqFieldset = optionsContainer.querySelector('.bsub-widget__delivery-fieldset');
  var freqContainer = null;
  var select = null;
  var freqRadios = [];

  if (freqFieldset) {
    freqRadios = Array.prototype.slice.call(
      freqFieldset.querySelectorAll('input[data-bsub-delivery-frequency-option]')
    );

    select = document.createElement('select');
    select.className = 'tl-bsub-select';

    freqRadios.forEach(function (r) {
      var opt = document.createElement('option');
      opt.value = r.value;
      var oc = r.closest('.bsub-option-container');
      var mainText = oc ? oc.querySelector('.bsub-widget__main-text') : null;

      function updateOptLabel() {
        var src = mainText ? mainText.textContent : r.value;
        var cleaned = bsubCleanFrequencyLabel(src);
        // Fall back to just the frequency name if cleaning stripped everything
        if (!cleaned) cleaned = r.value;
        if (opt.textContent !== cleaned) opt.textContent = cleaned;
      }
      updateOptLabel();

      // Bold may swap "{discount}" placeholders for real values after our
      // initial pass — keep the option label in sync.
      if (mainText) {
        var optObs = new MutationObserver(updateOptLabel);
        optObs.observe(mainText, {
          characterData: true,
          childList: true,
          subtree: true,
        });
      }

      if (r.checked) opt.selected = true;
      select.appendChild(opt);
    });

    select.addEventListener('change', function () {
      freqRadios.forEach(function (r) {
        if (r.value === select.value && !r.checked) {
          // Use click() so Bold's full chain (click + change handlers,
          // any onchange inline, plus their internal price recompute)
          // fires the same way as if the user picked the radio directly.
          r.click();
          if (!r.checked) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });

    freqContainer = document.createElement('div');
    freqContainer.className = 'tl-bsub-freq';
    freqContainer.innerHTML =
      '<div class="tl-bsub-section-title">Delivery Frequency</div>';
    freqContainer.appendChild(select);

    // Keep the original fieldset in DOM (Bold's logic still toggles state
    // on the radios) but hide it visually.
    freqFieldset.classList.add('tl-bsub-hidden');
  }

  // 5. Build the "How Subscriptions Work" checklist column.
  var howContainer = document.createElement('div');
  howContainer.className = 'tl-bsub-how';
  howContainer.innerHTML =
    '<div class="tl-bsub-section-title">How Subscriptions Work</div>' +
    '<ul class="tl-bsub-list"></ul>';
  var list = howContainer.querySelector('ul');

  function syncList() {
    list.innerHTML = '';

    // Dynamic discount text (may contain a <br> separating phases)
    var dyn = optionsContainer.querySelector('.bsub-widget__dynamic-discount-text');
    var dynLines = [];
    if (dyn) {
      dynLines = dyn.innerHTML
        .split(/<br\s*\/?>/i)
        .map(function (s) {
          var t = document.createElement('div');
          t.innerHTML = s;
          return t.textContent.trim();
        })
        .filter(Boolean);
      // Surface the "after X order(s)" line first to match target design.
      dynLines.sort(function (a, b) {
        var aOrd = /after.*order/i.test(a) ? 1 : 0;
        var bOrd = /after.*order/i.test(b) ? 1 : 0;
        return bOrd - aOrd;
      });
    }
    dynLines.forEach(function (line) {
      var li = document.createElement('li');
      li.innerHTML = '<span>' + line + '</span>';
      list.appendChild(li);
    });

    // Per-delivery price — Bold renders one per frequency option inside
    // each .bsub-option-container, so read from the currently-checked
    // option first; fall back to any global per-delivery node.
    var perDelText = '';
    var checkedFreq = optionsContainer.querySelector(
      'input[data-bsub-delivery-frequency-option]:checked'
    );
    if (checkedFreq) {
      var oc = checkedFreq.closest('.bsub-option-container');
      var ocPrice = oc && oc.querySelector('[data-bsub-per-delivery-price]');
      if (ocPrice) perDelText = ocPrice.textContent.trim();
    }
    if (!perDelText) {
      // Pick the first visible per-delivery price element as fallback.
      var anyPrice = optionsContainer.querySelector('[data-bsub-per-delivery-price]');
      if (anyPrice) perDelText = anyPrice.textContent.trim();
    }
    if (perDelText) {
      var liPrice = document.createElement('li');
      liPrice.innerHTML =
        '<span><strong>' + perDelText + '</strong>&nbsp;/ delivery</span>';
      list.appendChild(liPrice);
    }

    // Always-present convenience line
    var liCancel = document.createElement('li');
    liCancel.innerHTML = '<span>Change or cancel anytime</span>';
    list.appendChild(liCancel);
  }
  syncList();

  // 6. Wrap in two-column row.
  var row = document.createElement('div');
  row.className = 'tl-bsub-row';
  row.appendChild(howContainer);
  if (freqContainer) row.appendChild(freqContainer);
  optionsContainer.insertBefore(row, optionsContainer.firstChild);

  // 7. Move the "Subscription details" toggle into the left column.
  var extraActions = optionsContainer.querySelector('.bsub-widget__extra-actions');
  if (extraActions) howContainer.appendChild(extraActions);

  // 7b. Move the collapsible details panel INSIDE the Subscribe card so it
  //     expands above the One-time Purchase card instead of below it.
  var collapsible = widget.querySelector('[data-bsub-collapsible-wrapper]');
  if (collapsible) optionsContainer.appendChild(collapsible);

  // 8. Hide the now-duplicated dynamic discount block.
  var dynContainer = optionsContainer.querySelector('.bsub-widget__dynamic-discount-container');
  if (dynContainer) dynContainer.classList.add('tl-bsub-hidden');

  // 9. Keep our list & select in sync when Bold updates prices/discounts.
  //    Observe stable parent containers (the dynamic-discount block and
  //    the per-delivery price's parent) so we still catch updates even
  //    when Bold replaces inner nodes on frequency change.
  var moPending = false;
  var mo;
  function scheduleSync() {
    if (moPending) return;
    moPending = true;
    requestAnimationFrame(function () {
      moPending = false;
      // Disconnect while syncList mutates the DOM, then reconnect, so
      // we never loop on our own changes.
      if (mo) mo.disconnect();
      syncList();
      if (mo) mo.observe(optionsContainer, { characterData: true, childList: true, subtree: true });
    });
  }
  mo = new MutationObserver(function (mutations) {
    // Ignore mutations that originate from our own row to be extra safe.
    var external = mutations.some(function (m) {
      var n = m.target;
      while (n && n !== optionsContainer) {
        if (n.classList && n.classList.contains('tl-bsub-row')) return false;
        n = n.parentNode;
      }
      return true;
    });
    if (external) scheduleSync();
  });
  mo.observe(optionsContainer, { characterData: true, childList: true, subtree: true });

  // Mirror radio state -> select if changed externally, and re-sync the
  // list a few times to catch late price updates from Bold.
  widget.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-bsub-delivery-frequency-option]')) {
      if (select && select.value !== t.value) select.value = t.value;
      setTimeout(syncList, 50);
      setTimeout(syncList, 250);
      setTimeout(syncList, 600);
    }
  });

  widget.dataset.tlLayout = '1';
}

function bsubInitAllWidgets() {
  document.querySelectorAll('.bsub-widget').forEach(function (w) {
    bsubSyncMainTexts(w);
    bsubBuildLayout(w);
  });
}

function bsubObserveWidget() {
  // Initial attempt
  bsubInitAllWidgets();

  // Bold's widget may be injected after our script runs. Watch the body
  // for late insertion, then disconnect once we've successfully rebuilt.
  var pageObserver = new MutationObserver(function () {
    bsubInitAllWidgets();
    var widget = document.querySelector('.bsub-widget');
    if (widget && widget.dataset.tlLayout === '1') {
      // Switch to a narrower observer scoped to the widget itself so we
      // can keep cleaning up any text Bold re-renders.
      pageObserver.disconnect();
      var inner = new MutationObserver(function () {
        bsubSyncMainTexts(widget);
      });
      inner.observe(widget, { childList: true, subtree: true, characterData: true });
    }
  });
  pageObserver.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bsubObserveWidget);
} else {
  bsubObserveWidget();
}
